// Where the marketing site's links go. Pages folktale.io serves (nextportal
// routes and the folktale-ai snapshot rewrites in next.config.ts) stay
// relative; pages that only exist on folktale.ai link there so none 404.
const FOLKTALE_AI = "https://folktale.ai";

export const SITE_LINKS = {
  home: "/welcome",
  product: "/product",
  solutions: "/solutions",
  resources: "/resources",
  contact: "/contact",
  services: "/services",
  bids: "/bids",
  partners: "/partners",
  policies: "/policies",
  signIn: "/account/sign-in",
  startFree: "/fill-the-gap/about-me",
  gapAnalysis: `${FOLKTALE_AI}/gap-analysis`,
  faq: `${FOLKTALE_AI}/faq`,
  rightForMe: `${FOLKTALE_AI}/is-folktale-right-for-me`,
  packages: `${FOLKTALE_AI}/packages`,
  trustCentre: "https://app.vanta.com/folktale.io/trust/bgwsud2lgpsf5el43n7wj",
  docs: "https://docs.folktale.io",
} as const;

/** Opens off-site links in a new tab; folktale.io links stay in this tab. */
export function linkTarget(href: string) {
  return href.startsWith("http")
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};
}
